import { Flex, HStack, Text } from '@chakra-ui/react';
import { useMutation, useQuery } from '@tanstack/react-query';

import { Google } from '@/client/components/icons/ContinuIcons';
import IntegrationButton from './IntegrationButton';
import MeetsService from '@/client/services/api/integrations/MeetsService';
import { useToastStore } from '@/client/services/state/toastStore';
import { useTranslation } from 'react-i18next';

export default function GoogleMeetsIntegrationForm() {
  const { t } = useTranslation();
  const { setToast } = useToastStore();

  const { refetch, data } = useQuery({
    queryKey: ['google-meets-permission-link'],
    queryFn: () => MeetsService.meetsPermissionLink(),
  });

  const { data: existsData, refetch: refetchExists } = useQuery({
    queryKey: ['google-meets-exists-with-user'],
    queryFn: () => MeetsService.existsWithUser(),
  });

  const uninstallMutation = useMutation({
    mutationFn: () => MeetsService.uninstall(),
    onSuccess: (res: any) => {
      if (res.success === true) {
        refetch();
        refetchExists();
        setToast({
          show: true,
          status: 'success',
          title: t('learners.profile.settings.integrations.google.uninstall.success'),
        });
      }
    },
    onError: (err: any) => {
      console.log(err);

      setToast({
        show: true,
        status: 'error',
        title: t('learners.profile.settings.integrations.google.uninstall.error'),
      });
    },
  });

  const handleClick = () => {
    if (existsData && existsData.exists) uninstallMutation.mutate();
    else if (data) window.location.href = data.redirect_url;
  };

  return (
    <Flex justifyContent="space-between" alignItems="center">
      <HStack spacing={2}>
        <Google />

        <Text fontSize="14px" fontWeight={500} color="baseBlack">
          {t('learners.profile.settings.integrations.google.title')}
        </Text>
      </HStack>

      <IntegrationButton isEnabled={existsData?.exists} onClick={handleClick} />
    </Flex>
  );
}
